module.exports = __webpack_public_path__ + "img/uz.6964ce7b.svg";